var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 189,
    viewBox: "0 0 180 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179 94.5C179 146.185 139.108 188 90 188C40.8921 188 1 146.185 1 94.5C1 42.8148 40.8921 1 90 1C139.108 1 179 42.8148 179 94.5Z",
    stroke: "white",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.3511,
    cy: 62.2025,
    rx: 7.18085,
    ry: 7.17722,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.777,
    cy: 92.8253,
    rx: 7.18085,
    ry: 7.17722,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.771,
    cy: 48.0874,
    rx: 10.7713,
    ry: 10.7658,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.367,
    cy: 138.999,
    rx: 10.7713,
    ry: 10.7658,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.7181,
    cy: 116.989,
    rx: 4.54787,
    ry: 4.54557,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.388,
    cy: 112.204,
    rx: 4.54787,
    ry: 4.54557,
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.8351,
    cy: 149.525,
    rx: 4.54787,
    ry: 4.54557,
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.7766,
    cy: 122.013,
    rx: 9.57447,
    ry: 9.56962,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6543 22.4886L71.3202 27.6133L76.7113 27.6133L72.3498 30.7805L74.0157 35.9051L69.6543 32.7379L65.2928 35.9051L66.9587 30.7805L62.5972 27.6133L67.9883 27.6133L69.6543 22.4886Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.489 48.3265L148.854 55.6002H156.506L150.315 60.0956L152.68 67.3693L146.489 62.8739L140.299 67.3693L142.663 60.0956L136.473 55.6002H144.125L146.489 48.3265Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5372 78.9493L84.9882 83.4127H89.6837L85.885 86.1713L87.3359 90.6347L83.5372 87.8761L79.7385 90.6347L81.1895 86.1713L77.3908 83.4127H82.0862L83.5372 78.9493Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.234 154.071L108.631 158.369H113.153L109.495 161.025L110.892 165.323L107.234 162.667L103.576 165.323L104.973 161.025L101.315 158.369H105.837L107.234 154.071Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/Hot.5d2b4f16878c72c7c990cb4d705a0d93.svg";
export { ForwardRef as ReactComponent };